enum MetaContentType {
  ADDED_BY = 'added-by',
  UPDATED_BY = 'updated-by',
}

export default MetaContentType;
